export enum ProductServiceStatus {
  ACTIVE = 1,
  INACTIVE = 2,
  ONBOARDING = 3,
  SWITCHING = 4,
  DISABLING = 5,
  ENROLLING = 6, // only used for frontend
}
